import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Directory from "@/pages/Directory";
import InstitutionPage from "@/pages/InstitutionPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";
import Resolve from "@/pages/Resolve";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ErrorBoundary } from "@/components/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <AuthProvider>
          <div className="App">
            <Toaster position="bottom-right" theme="light" toastOptions={{ style: { borderRadius: 0 } }} />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Directory />} />
                <Route path="/category/:categorySlug" element={<Directory />} />
                <Route path="/state/:stateSlug" element={<Directory />} />
                <Route path="/bank/:slug" element={<InstitutionPage />} />
                <Route path="/nbfc/:slug" element={<InstitutionPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/resolve" element={<Resolve />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                {/* Catch-all 404 — must be LAST */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </div>
        </AuthProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
